import {gioiTinhOptions} from "assets/constants/select-catagory-options";
import React from "react";
import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import Moment from "moment";
import {ColumnProps} from "types/models";
import dayjs from "dayjs";

const {INPUT, SELECT, DATE, CHECKBOX} = FIELD_TYPE;

const getImageSrc = imageId => {
  return `${window.REACT_APP_BE_URL}/qlkhambenh/upload-images?imageId=${imageId}`;
};

const extendCardSetFieldsValue = (form, dataPassing) => {
  form.setFieldsValue({
    ...dataPassing,
    ngaySinh: dataPassing.ngaySinh ? dayjs(dataPassing.ngaySinh) : null,
    ngayBatDau: dataPassing.ngayBatDau ? dayjs(dataPassing.ngayBatDau) : null,
    ngayKetThuc: dataPassing.ngayKetThuc
      ? dayjs(dataPassing.ngayKetThuc)
      : null,
  });
};

const extendInfoFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 8,
    },
    labelCol: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    wrapperCol: {xs: 18, sm: 18, md: 18, lg: 18, xl: 18},
    rules: [{required: true, message: "Mã bệnh nhân là bắt buộc"}],
  },
  {
    type: INPUT,
    label: "Tên trên thẻ",
    name: "hoTen",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 8,
    },
    labelCol: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    wrapperCol: {xs: 18, sm: 18, md: 18, lg: 18, xl: 18},
    rules: [{required: true, message: "Tên trên thẻ là bắt buộc"}],
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 8,
    },
    labelCol: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    wrapperCol: {xs: 18, sm: 18, md: 18, lg: 18, xl: 18},
    rules: [{required: true, message: "Ngày sinh là bắt buộc"}],
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    options: gioiTinhOptions,
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 8,
    },
    labelCol: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    wrapperCol: {xs: 18, sm: 18, md: 18, lg: 18, xl: 18},
  },
  {
    type: DATE,
    label: "Hiệu lực từ",
    name: "ngayBatDau",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 8,
    },
    labelCol: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    wrapperCol: {xs: 18, sm: 18, md: 18, lg: 18, xl: 18},
  },
  {
    type: DATE,
    label: "Hiệu lực đến",
    name: "ngayKetThuc",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 8,
      xl: 8,
    },
    labelCol: {xs: 6, sm: 6, md: 6, lg: 6, xl: 6},
    wrapperCol: {xs: 18, sm: 18, md: 18, lg: 18, xl: 18},
    rules: [{required: true, message: "Hiệu lực đến là bắt buộc"}],
  },
  {
    type: INPUT,
    label: "Địa chỉ in trên thẻ",
    name: "diaChi",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    labelCol: {xs: 3, sm: 3, md: 3, lg: 2, xl: 2},
    wrapperCol: {xs: 20, sm: 20, md: 20, lg: 22, xl: 22},
  },
  {
    type: DATE,
    label: "Gia hạn từ",
    name: "giaHanTu",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    labelCol: {xs: 4, sm: 4, md: 4, lg: 4, xl: 4},
    wrapperCol: {xs: 20, sm: 20, md: 20, lg: 20, xl: 20},
    rules: [{required: true, message: "Chọn ngày bắt đầu gia hạn"}],
  },
  {
    type: DATE,
    label: "Gia hạn đến",
    placeholder: "DD/MM/YYYY",
    name: "giaHanDen",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    labelCol: {xs: 4, sm: 4, md: 4, lg: 4, xl: 4},
    wrapperCol: {xs: 20, sm: 20, md: 20, lg: 20, xl: 20},
    rules: [{required: true, message: "Chọn ngày gia đến"}],
  },
];

const listPatientColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    align: "center",
    render: (v, r, idx) => {
      return <>{idx + 1}</>;
    },
    show: true,
  },
  {
    title: "Mã bệnh nhân",
    key: "maBenhNhan",
    dataIndex: "maBenhNhan",
    align: "right",
    show: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    dataIndex: "hoTen",
    align: "left",
    show: true,
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    dataIndex: "gioiTinh",
    align: "left",
    show: true,
    render: v => {
      return v == 0 ? <>Nam</> : <>Nữ</>;
    },
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    key: "ngaySinh",
    align: "right",
    show: true,
    render: (v, r, idx) => {
      return v ? <>{Moment(v).format("DD/MM/YYYY")}</> : null;
    },
  },
  {
    title: "Trạng thái thẻ",
    dataIndex: "trangThaiThe",
    key: "trangThaiTher",
    align: "left",
    show: true,
    render: (v, r, idx) => {
      if (v === 0) {
        return "Chưa in";
      } else if (v === 1) {
        return "Đã in";
      }
    },
  },
  {
    title: "Ngày tiếp nhận từ",
    dataIndex: "ngayBatDau",
    key: "ngaySinh",
    align: "right",
    render: (v, r, idx) => {
      return v ? <>{Moment(v).format("DD/MM/YYYY")}</> : null;
    },
    show: true,
  },
  {
    title: "Ngày tiếp nhận đến",
    dataIndex: "ngayKetThuc",
    key: "ngayKetThuc",
    align: "right",
    show: true,
    render: (v, r, idx) => {
      return v ? <>{Moment(v).format("DD/MM/YYYY")}</> : null;
    },
  },
];

export {
  extendInfoFields,
  extendCardSetFieldsValue,
  listPatientColumns,
  getImageSrc,
};
